function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "prefix__browser_1_",
  "data-name": "browser (1)",
  transform: "translate(0 -16.017)"
}, React.createElement("path", {
  id: "prefix__Path_5",
  d: "M50.419 200.169h-9.177A1.243 1.243 0 0 1 40 198.928v-6.533a.432.432 0 1 1 .864 0v6.533a.378.378 0 0 0 .378.378h9.178a.378.378 0 0 0 .378-.378v-6.533a.432.432 0 1 1 .864 0v6.533a1.243 1.243 0 0 1-1.243 1.241z",
  className: "prefix__cls-1",
  "data-name": "Path 5",
  transform: "translate(-38.92 -171.197)"
}), React.createElement("path", {
  id: "prefix__Path_6",
  d: "M13.389 22.71a.43.43 0 0 1-.305-.127l-5.372-5.371a1.135 1.135 0 0 0-1.6 0L.738 22.583a.432.432 0 0 1-.611-.611L5.5 16.6a2 2 0 0 1 2.825 0l5.371 5.371a.432.432 0 0 1-.305.737z",
  className: "prefix__cls-1",
  "data-name": "Path 6"
}), React.createElement("path", {
  id: "prefix__Path_7",
  d: "M179.887 293.6h-3.455a.432.432 0 0 1-.432-.432v-3.833a1.351 1.351 0 0 1 1.35-1.35h1.62a1.351 1.351 0 0 1 1.35 1.35v3.833a.432.432 0 0 1-.433.432zm-3.023-.864h2.591v-3.4a.486.486 0 0 0-.486-.486h-1.62a.486.486 0 0 0-.486.486z",
  className: "prefix__cls-1",
  "data-name": "Path 7",
  transform: "translate(-171.249 -264.625)"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 13.82,
    height: 12.956,
    viewBox: "0 0 13.82 12.956"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/browser.eb4e0a2f.svg";
export { SvgComponent as ReactComponent };